module.exports = __webpack_public_path__ + "img/stock1.9f9b611a.png";